var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"iframe"},[_c('iframe',{staticClass:"iframe__embed",attrs:{"src":_vm.node.attrs.src,"width":"560","height":"315","frameborder":"0","allowfullscreen":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }